// table pagination
ht.declare('table.paginate', function () {
  $(this).paginate();
});
